import { Alert, IconButton, Portal, Snackbar } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const AlertSnackBar = ({ open, closeSnackBar, type, message }) => {
  return (
    <Portal>
      <Snackbar
        sx={{ direction: "ltr" }}
        open={open}
        autoHideDuration={6000}
        onClose={closeSnackBar}
      >
        <Alert
          variant="filled"
          severity={type}
          color={type === "success" ? "success" : "error"}
          action={
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={closeSnackBar}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          }
        >
          {message}
        </Alert>
      </Snackbar>
    </Portal>
  );
};

export default AlertSnackBar;
